import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { WSProvider } from './contexts/WSContext';

import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPrices from './pages/admin/AdminPrices';
import AdminReports from './pages/admin/AdminReports';

import AdminUsers from './pages/admin/AdminUsers';

function Guard({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="mobile-shell flex items-center justify-center">
      <img src="/logo.png" alt="logo" className="w-24 h-24 object-contain animate-bounce" />
    </div>
  );
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== 'admin') {
    localStorage.removeItem('token');
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <div className="mobile-shell">
      <Toaster position="top-center" toastOptions={{ style: { fontSize: 14, borderRadius: 12 } }} />
      <Routes>
        <Route path="/" element={
          user && user.role === 'admin'
            ? <Navigate to="/admin" replace />
            : <Navigate to="/admin/login" replace />
        } />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Guard><AdminDashboard /></Guard>} />
        <Route path="/admin/precos" element={<Guard><AdminPrices /></Guard>} />
        <Route path="/admin/relatorios" element={<Guard><AdminReports /></Guard>} />
        <Route path="/admin/usuarios" element={<Guard><AdminUsers /></Guard>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WSProvider>
          <AppRoutes />
        </WSProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
